var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10073 9.99219H0L5.59853 19.1453C6.00773 19.8127 6.64012 20.2704 7.36551 20.442L9.72768 16.2087L6.10073 9.99219Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20032_48717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 20,
    width: 6,
    height: 1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03513 20.5181H12.1085L7.64453 20.499C7.77473 20.5181 7.90493 20.5181 8.03513 20.5181Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20032_48717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1261 20.499H7.66211V20.5181H12.1261V20.499Z",
    fill: "url(#paint0_linear_20032_48717)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20032_48717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 20,
    width: 1,
    height: 1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34668 20.4991H7.66288C7.56988 20.48 7.47688 20.461 7.38388 20.4419L7.34668 20.4991Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20032_48717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66288 20.4419H7.34668V20.4991H7.66288V20.4419Z",
    fill: "url(#paint1_linear_20032_48717)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20032_48717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 16,
    width: 6,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36426 20.4418C7.45726 20.4609 7.55026 20.4799 7.64325 20.499L12.1072 20.5181L9.72643 16.2085L7.36426 20.4418Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20032_48717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1072 16.2085H7.36426V20.5181H12.1072V16.2085Z",
    fill: "url(#paint2_linear_20032_48717)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20032_48717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 16,
    width: 6,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36426 20.4418C7.45726 20.4609 7.55026 20.4799 7.64325 20.499L12.1072 20.5181L9.72643 16.2085L7.36426 20.4418Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20032_48717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1072 16.2085H7.36426V20.5181H12.1072V16.2085Z",
    fill: "url(#paint3_linear_20032_48717)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_20032_48717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 16,
    width: 4,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1269 20.5181L9.72754 16.2085L12.1269 20.5181Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_20032_48717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1269 16.2085H9.72754V20.5181H12.1269V16.2085Z",
    fill: "url(#paint4_linear_20032_48717)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_20032_48717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 18,
    height: 17
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9804 0C19.9016 0 19.139 0.495793 18.674 1.43017L11.8851 12.6427L9.72754 16.2086H15.7725L26.1139 0H20.9804Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_20032_48717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1139 0H9.72754V16.2086H26.1139V0Z",
    fill: "url(#paint5_linear_20032_48717)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20032_48717",
    x1: 7.65487,
    y1: 20.5035,
    x2: 12.1177,
    y2: 20.5035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20032_48717",
    x1: 7.34242,
    y1: 20.4676,
    x2: 7.65717,
    y2: 20.4676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20032_48717",
    x1: 7.37006,
    y1: 18.3654,
    x2: 12.1179,
    y2: 18.3654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20032_48717",
    x1: 7.37006,
    y1: 18.3654,
    x2: 12.1179,
    y2: 18.3654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20032_48717",
    x1: 9.72395,
    y1: 18.3681,
    x2: 12.1199,
    y2: 18.3681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20032_48717",
    x1: 9.7212,
    y1: 8.09738,
    x2: 26.1038,
    y2: 8.09738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.bfaa1e9ca828e5355e5b54c559840ed2.svg";
export { ForwardRef as ReactComponent };